import axios, { CancelTokenSource } from 'axios';
import { serviceUrl } from '../../../App';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
export const getContainer = (obj: any, tokenSource?: CancelTokenSource) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `dig/container?org_id=` + obj.org_id,
    {
      cancelToken: tokenSource?.token,
    }
  );
};
export const AddContainer = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/container/add`,
    obj,
    {
      headers,
    }
  );
};

export const EditContainer = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/container/update`,
    obj,
    {
      headers,
    }
  );
};

export const DeleteContainer = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/container/delete`,
    obj,
    {
      headers,
    }
  );
};

export const getContainerTask = (
  id: number,
  tokenSource?: CancelTokenSource
) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `dig/container/task?where=` + id,
    {
      cancelToken: tokenSource?.token,
    }
  );
};
export const getContainerTaskAll = (
  obj: any,
  tokenSource?: CancelTokenSource
) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `dig/container/all-task-no-container?org_id=` +
      obj.org_id,
    {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
      cancelToken: tokenSource?.token,
    }
  );
};
export const getContainerTaskOne = (
  container_task_id: number,
  tokenSource?: CancelTokenSource
) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `dig/container/task-one?where=` +
      container_task_id,
    {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
      cancelToken: tokenSource?.token,
    }
  );
};
export const AddContainerTask = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/container/task/add`,
    obj,
    { headers }
  );
};
export const EditContainerTask = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/container/task/update`,
    obj,
    { headers }
  );
};

export const DeleteContainerTask = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/container/task/delete`,
    obj,
    { headers }
  );
};
